<template lang="pug">
#startflow(v-loading="loading" element-loading-text="数据处理中...")
  .left
    .stageTitle 基本信息
    component(ref="businessForm"
      :is="basicForm"
      :flowMessage="flowMessage"
      :prjId="approvalPrjId"
      :flowDefinitionId="flowMessage.flowDefinitionId"
      :formId="formId"
      :key="comKey"
      flowModeStatus="approve"
      @loadComplete="loadComplete")
    //- 兼容代码组件使用上传的文件，后期建议抛弃
    viewFileEditor(ref="viewFileEditor" :flowKey="flowKey" noDelete)

    template(v-if="fileList.length>0")
      .uploaderTitle 流程附件
      viewFileList(ref="viewFileList" :files="fileList"  noDelete)
    .check
      el-button(size="small", type="primary", plain, @click="queryFlowImage") 查询流程图
    .flowShowImage(v-if="showType === 'img'")
      el-image(:src="flowImage" :previewSrcList="[flowImage]")
  .right
    flowNodesEditor(
      ref="flowNodesEditor"
      nodeType="runTime"
      :flowMessage="flowMessage"
      :getBasicData="getBasicData"
      :viewMode="viewMode"
      @closeDialog="closeDialog" )
</template>

<script>
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import { getFormComponent } from "../config/flowFormRegister";
import viewFileList from "../config/viewFileList.vue";
import viewFileEditor from "../config/viewFileEditor.vue";
import { getFlowImage } from "@/CommonDP/utils";
import flowNodesEditor from "../config/flowNodesEditor.vue";
import customVform from "@/CommonDP/pages/mainMg/lowcode/component/vFormRender.vue";
import { approveParams, setStartAttachedFiles, setPrjID, setDefaultApproval } from "../config";
import { getFormRequest } from "../config/flowFormRegister";
export default {
  components: { viewFileList, flowNodesEditor, customVform, viewFileEditor },
  props: {
    viewMode: { // 审批1 查看2
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      loading: false,
      flowMessage: {},
      detailMessage: "",
      floderData: [],
      basicForm: "",
      showSteps: false,
      approvalPrjId: "",
      showType: "", // user:处理人 ,img:流程图
      comKey: 0,
      nodes: []
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    fileList() {
      return this.floderData.map(e => {
        return {
          ...e,
          fileId: e.fileId,
          fileName: e.fileName
        };
      });
    },
    version() {
      return approveParams.version || "";
    },
    definitionId() {
      return approveParams.definitionId || "";
    },
    flowKey() {
      return approveParams.flowKey || "0";
    },
    flowInstanceId() {
      return approveParams.detail.flowInstanceId;
    },
    formId() {
      return this.flowMessage.formApprovePcCode || this.flowMessage.formCode;
    },
    // 是否调用标准的流程接口:std 是 ，customize 否
    isMethodInvokeMode() {
      return approveParams.methodInvokeMode === "std";
    },
    // 是否低代码 true ：是
    isLowCode() {
      return this.flowMessage.customerForm === 2;
    },
    flowImage() {
      return getFlowImage(this.flowMessage.flowImage.slice(7));
    }
  },
  methods: {
    // 流程详情启动
    async flowDetail() {
      this.loading = true;
      let res = "";
      if (this.isMethodInvokeMode) {
        res = await flowService.queryFlowDef(this.version, this.definitionId, this.flowKey);
      } else {
        const params = {
          flowVersionId: this.version,
          flowDefinitionId: this.definitionId,
          flowKey: this.flowKey
        };
        const url = getFormRequest().getRequestType(this.flowKey, "queryDetail", params);
        if (!url) {
          this.$message.warning(`该表单：${this.flowKey} 未配置对应的流程详情接口`);
          return false;
        }
        res = await url;
      }
      this.flowMessage = res.data || {};
      this.nodes = JSON.parse(res.data.nodes);
      this.floderData = res.data.attachedFiles || [];
      this.comKey++;
      if (this.flowMessage.customerForm === 2) { // 低代码设计的表单
        this.basicForm = customVform;
      } else { // 自定义表单
        const params = {
          ...res.data,
          name: res.data.flowName,
          prjId: this.approvalPrjId
        };
        this.$store.dispatch("setRouterParams", params);
        this.basicForm = getFormComponent(this.flowMessage.flowKey);
        await this.$nextTick();
        await this.getFormData();
        await this.$nextTick();
        // 非低代码默认不可修改
        this.$refs.businessForm.disableForm?.();
        // 兼容开发页面
        if (!this.$refs.businessForm.disableForm) {
          this.$refs.businessForm.flowStatus = true;
        }
        this.loading = false;
        await this.$refs.flowNodesEditor.stepsOpen();
      }
    },
    // 低代码表单加载完毕
    async loadComplete() {
      await this.getFormData();
      setDefaultApproval(this.flowMessage, this.enterpriseId);
      if (this.isLowCode) {
        const { $refs: { businessForm: { formData }}} = this;
        const id = this.$refs.businessForm.getPrjId();
        // console.log("预览的项目id:formData[id]", formData[id]);
        setPrjID(formData[id]);
      }
      this.loading = false;
      await this.$refs.flowNodesEditor.stepsOpen();
    },
    // 获取数据信息-设置字段信息，塞值
    async getFormData() {
      const res = await flowService.getBusinessForm(this.flowInstanceId);
      this.detailMessage = res.data || {};
      // 附件列表
      setStartAttachedFiles(res.data.fileInfoList || []);
      // 低代码 非查看模式配置字段信息：显隐、只读、必填
      if (this.isLowCode && this.viewMode !== 2) {
        const formFieldPermissionList = res.data.formFieldPermissionList || [];
        this.$refs.businessForm.setFormPremission(formFieldPermissionList);
      } else if (this.isLowCode && this.viewMode === 2) { // 查看
        this.$refs.businessForm.disableForm?.();
      }
      const formData = res.data.object || {};
      this.$refs.businessForm.setFormData(formData);
    },
    // 获取基本信息数据
    getBasicData() {
      return this.$refs.businessForm.getFormData();
    },
    queryFlowImage() {
      this.showType = "img";
    },
    closeDialog() {
      this.$emit("closeDialog");
    }
    // 校验表单是否把必填项输入
    // async startValidate() {
    //   // 低代码表单校验
    //   if (this.flowMessage.customerForm === 2) {
    //     return await this.$refs.businessForm.startValidate();
    //   } else {
    //     return await this.$refs.businessForm.validateFormData();
    //   }
    // },
  }
};
</script>

<style lang="scss" scoped>
#startflow{
  width: 100%;
  height:600px;
  padding: 0 10px;
  display: flex;
  flex-direction: row;
  overflow-x: hidden;
  overflow-y: auto;
  .left{
    width: calc(100% - 400px);
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 10px;
    transition: all 0.3s;
    padding-bottom: 25px;
  }
  // .showNode{
  //   width: calc(100% - 400px);
  //   transition: all 0.3s;
  // }
  .right{
    width: 400px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    transition: all 0.3s;
  }
  .stageTitle{
    height: 40px;
    font-weight: 700;
    font-size: 16px;
    line-height: 40px;
    color: var(--theme-color);
    border-bottom: 1px solid #ebefff;
    margin-bottom: 10px;
  }
}
.uploaderTitle{
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebefff;
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 16px;
  line-height: 40px;
  color: var(--theme-color);
}
.check {
  margin-top: 5px;
  height: 45px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.flowShowImage{
  width: 100%;
  img{
    width: 100%;
    object-fit: contain;
  }
}
</style>
